// Generated by ReScript, PLEASE EDIT WITH CARE

import * as V2$Linear from "lumi-linear/lib/es6/src/V2.res.js";
import * as M23$Linear from "lumi-linear/lib/es6/src/M23.res.js";
import * as V2f$Linear from "lumi-linear/lib/es6/src/V2f.res.js";
import * as M23f$Linear from "lumi-linear/lib/es6/src/M23f.res.js";
import * as Rectf$Linear from "lumi-linear/lib/es6/src/Rectf.res.js";
import * as Recti$Linear from "lumi-linear/lib/es6/src/Recti.res.js";
import * as Radians$Linear from "lumi-linear/lib/es6/src/Radians.res.js";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";
import * as Transform$Linear from "lumi-linear/lib/es6/src/Transform.res.js";

function fromRect(param) {
  let match = V2f$Linear.mapToString(param.pos);
  let match$1 = V2f$Linear.mapToString(param.size);
  return match[0] + ` ` + match[1] + ` ` + match$1[0] + ` ` + match$1[1];
}

function fromSize(size) {
  return fromRect(Rectf$Linear.fromSize(size));
}

let Float = {
  fromRect: fromRect,
  fromSize: fromSize
};

function fromRect$1(param) {
  let match = V2$Linear.map(param.pos, x => x.toString());
  let match$1 = V2$Linear.map(param.size, x => x.toString());
  return match[0] + ` ` + match[1] + ` ` + match$1[0] + ` ` + match$1[1];
}

function fromSize$1(size) {
  return fromRect$1(Recti$Linear.fromSize(size));
}

let Int = {
  fromRect: fromRect$1,
  fromSize: fromSize$1
};

let ViewBox = {
  Float: Float,
  Int: Int
};

function list(__x) {
  return __x.join(" ");
}

function fromM23f(mat) {
  let match = M23$Linear.map(mat, x => x.toString());
  let match$1 = match[1];
  let match$2 = match[0];
  return `matrix(` + match$2[0] + ` ` + match$1[0] + ` ` + match$2[1] + ` ` + match$1[1] + ` ` + match$2[2] + ` ` + match$1[2] + `)`;
}

function fromM23f_(mat) {
  if (Primitive_object.equal(mat, Transform$Linear.M23f.identity)) {
    return;
  } else {
    return fromM23f(mat);
  }
}

function fromM33f(param) {
  return fromM23f([
    param[0],
    param[1]
  ]);
}

let Matrix = {
  fromM23f: fromM23f,
  fromM23f_: fromM23f_,
  fromM33f: fromM33f
};

function skewX(angle) {
  let a = angle.toString();
  return `skewX(` + a + `)`;
}

function skewY(angle) {
  let a = angle.toString();
  return `skewY(` + a + `)`;
}

function rotate(angle) {
  let a = angle.toString();
  return `rotate(` + a + `)`;
}

let Degree = {
  skewX: skewX,
  skewY: skewY,
  rotate: rotate
};

function translate(vec) {
  let match = V2f$Linear.mapToString(vec);
  return `translate(` + match[0] + ` ` + match[1] + `)`;
}

function scale(vec) {
  let match = V2f$Linear.mapToString(vec);
  return `scale(` + match[0] + ` ` + match[1] + `)`;
}

function rotateAround(angle, around) {
  let a = angle.toString();
  let match = V2f$Linear.mapToString(around);
  return `rotate(` + a + ` ` + match[0] + ` ` + match[1] + `)`;
}

let Degree$1 = {
  rotateAround: rotateAround
};

function rotateAround$1(angle, around) {
  return rotateAround(Radians$Linear.toDegrees(angle), around);
}

let Radian = {
  rotateAround: rotateAround$1
};

let Float$1 = {
  translate: translate,
  scale: scale,
  Degree: Degree$1,
  Radian: Radian
};

let Transform = {
  list: list,
  Matrix: Matrix,
  Degree: Degree,
  Float: Float$1
};

function domMatrixToM23f(param) {
  return [
    [
      param.a,
      param.c,
      param.e
    ],
    [
      param.b,
      param.d,
      param.f
    ]
  ];
}

function screenSpaceToViewportCoordinates(svgElement, screenPoint) {
  let ctm = domMatrixToM23f(svgElement.getScreenCTM());
  return Transform$Linear.M23f.apply(V2$Linear.map(screenPoint, prim => prim), M23f$Linear.inverse(ctm));
}

function mouseEventToViewportCoordinates(event, svgElement) {
  return screenSpaceToViewportCoordinates(svgElement, [
    event.clientX,
    event.clientY
  ]);
}

function pointerEventToViewportCoordinates(event, svgElement) {
  return screenSpaceToViewportCoordinates(svgElement, [
    event.clientX,
    event.clientY
  ]);
}

export {
  ViewBox,
  Transform,
  domMatrixToM23f,
  screenSpaceToViewportCoordinates,
  mouseEventToViewportCoordinates,
  pointerEventToViewportCoordinates,
}
/* V2f-Linear Not a pure module */
